<template>
<v-layout row wrap>
<!-- <v-flex xs12 sm6 offset-sm3> -->
  <v-flex xs12>
    <v-card>
      <v-data-table
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :headers="headers"
        :items="places"
        :loading="loading">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.assignedChargerSummary }}</td>
          <td class="text-xs-left">{{ props.item.model }}</td>
          <td class="text-xs-left">{{ props.item.assignedCheckerSummary }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
// import firebase from 'firebase'

export default {
  name: 'Assignment',
  components: {
    // empty
  },
  data () {
    return {
      headers: [{text: '충전소', values: 'place', sortable: false},
        {text: '충전기', values: 'charger', sortable: false},
        {text: '플러그', values: 'plug', sortable: false},
        {text: '점검자', values: 'checker', sortable: false}],
      places: [],
      chargers: [],
      checkers: [],
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        rowsPerPage: 10
      },
      loading: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getPlaces()
    }
  },
  created () {
    this.$emit('title', '배치')
    this.$_getPlaces()
  },
  methods: {
    $_getPlaces () {
      this.$fs
        .collection('places')
        .where('group', '==', this.$store.state.session.group)
        .orderBy('name')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            item.assignedChargers = []
            item.assignedCheckers = []
            item.assignedChargerSummary = ''
            item.assignedCheckerSummary = ''
            this.places.push(item)
            // this.items.push({ divider: true, inset: false })
            // console.log(doc.data())
          })

          this.$_getChargers()
          this.$_getCheckers()

          console.log(this.places)
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    $_getChargers () {
      this.$fs
        .collection('chargers')
        .where('group', '==', this.$store.state.session.group)
        .orderBy('managementNumber')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id

            for (var i = 0; i < this.places.length; i++) {
              var place = this.places[i]
              place.assignedChargers = []

              // console.log('place', place.id)

              if (item.placeRef != null && place.id === item.placeRef.id) {
                // console.log(place.checkerRef)
                place.assignedChargers.push(item)
                place.assignedChargerSummary += item.managementNumber + ', '
                break
              }
            } // for

            this.chargers.push(item)
          })
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    $_getCheckers () {
      this.$fs
        .collection('checkers')
        .where('group', '==', this.$store.state.session.group)
        .orderBy('name')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id

            for (var i = 0; i < this.places.length; i++) {
              var place = this.places[i]
              place.assignedCheckers = []

              // console.log('place', place.id)

              if (place.checkerRef != null && place.checkerRef.id === item.id) {
                console.log(place.name, place.checkerRef, item.name)
                place.assignedCheckers.push(item)
                place.assignedCheckerSummary = item.name
                break
              }
            } // for

            this.checkers.push(item)
          }) // forEach
        }) // then
        .catch(error => {
          console.log('error', error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Assignment.vue